import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/yelloop.svg'


const _withScopeId = n => (_pushScopeId("data-v-ee21592a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container pt-5" }
const _hoisted_2 = { class: "d-flex justify-content-center mb-1 heading pb-3 pb-sm-0" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo"
}, null, -1))
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "line col-lg-3" })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "main-title text-center fw-bold" }, /*#__PURE__*/_toDisplayString('受信したコードを入力してください。'), -1))
const _hoisted_7 = { class: "text-align-center fs-7 pb-2" }
const _hoisted_8 = { class: "col-lg-3 col-7 col-md-5 justify-self-center pb-4 mx-auto" }
const _hoisted_9 = {
  key: 0,
  class: "invalid-feedback pb-3"
}
const _hoisted_10 = {
  key: 1,
  class: "text-align-center fs-7 pt-2"
}
const _hoisted_11 = { class: "d-flex justify-content-center" }
const _hoisted_12 = { class: "text-align-center fs-7 pt-3" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('コードが届かない場合は ') + " ")
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString(' をご確認ください'))

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import { ref, onMounted, computed, watch } from 'vue'
import employeesServices from '@/services/employees.service'
import { getCookie, safeCookieParse, setHeaders } from '@/utils'
import axios from 'axios'
import { PATH } from '@/constants'
import { useRoute, useRouter } from 'vue-router'
import { debounce, omit } from 'lodash'
import { useCountdown } from '@/use/useCountdown'
import { inquiryEmployeeSA81 } from '@/constants/common'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const pin_code = ref<string>('')
const route = useRoute()
const router = useRouter()
const pathHeader = PATH[`${route.path.split('/')[1]}`]
const basePath = `/${route.path.split('/')[1]}`
const checkPaths = [`${basePath}/2fa_notification`, `${basePath}/input_authentication_code`]
const oneTimePwdObj = getCookie(`${pathHeader.header}-one-time`)
const cookieParse = safeCookieParse(oneTimePwdObj)
const one_time_password = cookieParse ? cookieParse?.one_time_password : ''
const authen_method = cookieParse ? cookieParse?.authentication_method : 0

const regexValid = computed(() => /^\d*$/.test(pin_code.value.trim()))
const regexValidDisable = computed(() => /^\d{6}$/.test(pin_code.value.trim()))
const touched = ref(false)
const errorApi = ref<boolean>(false)
const isValid = computed(() => {
  if (!regexValid.value) return false
  if (errorApi.value) return false
  return true
})
const { timeLeft, showCountTime, startCountdown } = useCountdown(`countdownEndTime_${pathHeader.path}_${route.meta.screenId}`)
const resendButton = ref<boolean>(false)
const submittingButton = ref<boolean>(false)

watch(pin_code, (newVal, oldVal) => {
  if (newVal !== '') {
    touched.value = true
  }
})
watch(showCountTime, (newVal) => {
  resendButton.value = newVal
})

const resendCode = debounce(async () => {
  resendButton.value = true
  startCountdown(30)
  try {
    await employeesServices.employeesResendCode({
      one_time_password: one_time_password,
    })
  } catch (error) {
    resendButton.value = false
    console.error(error)
  }
}, 200)
const sendParamsDataLayer = (data: any) => {
  ;(window as any).dataLayer = (window as any).dataLayer || []
  ;(window as any).dataLayer.push({
    event: `${process.env.VUE_APP_GTM_EVENT}`,
    unique_user_id: data?.data?.gtm_user_id || null,
    community_id: null,
    user_type: '在籍ユーザ',
    page_url: window.location.href,
  })
}
const onSubmit = debounce(async () => {
  submittingButton.value = true
  try {
    const data = await employeesServices.employeesCheckCode2Fa({
      pin_code: pin_code.value,
      one_time_password: one_time_password,
    })
    // Push dataLayer
    sendParamsDataLayer(data)
    if (data.headers?.expiry) {
      axios.defaults.headers['X-CSRF-TOKEN'] = data.headers['access-token']
      const { expiry } = data.headers
      // 2022/10/21 CW-TrungNT Fix UAT#4684: CA80, SA80 (Ph2-R20221021)
      let expires = `${expiry ? new Date(parseInt(expiry) * 1000).toUTCString() : new Date()['toGMTString']()}`

      const basePath = PATH[`${route.path.split('/')[1]}`]
      const dataHeader = { ...data.headers, 'request-path': basePath.path }

      document.cookie = `${basePath.pathName}=${basePath.path}; expires=${expires}; path=/`
      if (route.path !== '/community/users/login') {
        document.cookie = `invited_code=${route.params?.key ?? ''}; expires=${expires}; path=/`
      }
      document.cookie = `${basePath.header}=${JSON.stringify(omit(dataHeader, ['cache-control', 'content-type']))}; expires=${expires}; secure; path=/`
      setHeaders(dataHeader)
      errorApi.value = false
      redirectPage()
    } else {
      handleApiErrorSubmit(data)
    }
  } catch (error) {
    handleApiErrorSubmit(error)
  }
}, 200)

const handleApiErrorSubmit = (error) => {
  const messageCode = error?.response?.data?.data?.[0]?.message_code
  // If the message code is ERROR_TWO_FACTOR_AUTH_FAILED and in case network not connected
  // We should not show the error under input, already handle by toast error show
  errorApi.value = messageCode != 'ERROR_TWO_FACTOR_AUTH_FAILED' && window.navigator.onLine
  submittingButton.value = false
}
const redirectPage = (): void => {
  const defaultUrl = `/${route.path.split('/')[1]}/lobby`
  const redirect = getCookie(`${pathHeader.path}-redirect-path`) ?? defaultUrl
  if (!checkPaths.includes(redirect)) {
    document.cookie = `${pathHeader.path}-redirect-path=${redirect ?? ''}; path=/`
  }
  router.push(redirect)
  localStorage.removeItem(`countdownEndTime_${pathHeader.path}_${route.meta.screenId}`)
}
onMounted(() => {
  const hasHeaders = getCookie(pathHeader?.header)
  if (hasHeaders && oneTimePwdObj) {
    router.push(`/${route.path.split('/')[1]}/lobby`)
    return
  }
  if (hasHeaders && !oneTimePwdObj) {
    router.push(`/${route.path.split('/')[1]}/2fa_notification`)
    return
  }
  return
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(translate)('SD10heading')), 1)
    ]),
    _hoisted_5,
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(authen_method) === 1 ? 'SMSでコードを送信しています。' : _unref(authen_method) === 2 ? 'メールでコードを送信しています。' : ''), 1),
    _createElementVNode("div", _hoisted_8, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        name: "code",
        pattern: "\\d{6}",
        maxlength: "6",
        class: _normalizeClass(['form-control text-center', touched.value && !_unref(isValid) ? 'is-invalid' : '']),
        inputmode: "numeric",
        autocomplete: "one-time-code",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pin_code).value = $event)),
        onInput: _cache[1] || (_cache[1] = ($event: any) => (errorApi.value = false))
      }, null, 34), [
        [_vModelText, pin_code.value]
      ]),
      (touched.value && !_unref(isValid))
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(!_unref(regexValid) ? _unref(translate)('validateNumber') : errorApi.value && _unref(translate)('ERROR_TWO_FACTOR_AUTH')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(['resend-code', 'pt-2', _unref(showCountTime) || resendButton.value ? 'disable-resend' : '']),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (!_unref(showCountTime) || !resendButton.value ? _unref(resendCode)() : null))
      }, _toDisplayString('コードを再送する'), 2),
      (_unref(showCountTime))
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(timeLeft)) + "秒後に再送可能です ", 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(Button, {
        title: "次へ",
        type: 'secondary',
        className: 'me-2',
        disabled: !_unref(regexValidDisable) || submittingButton.value,
        onClick: _unref(onSubmit)
      }, null, 8, ["disabled", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("a", {
        href: `${_unref(inquiryEmployeeSA81)}`,
        target: "_blank",
        class: "text-dark"
      }, "こちら", 8, _hoisted_14),
      _hoisted_15
    ])
  ]))
}
}

})